import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 45000 }
  }

  connect () {
    this.ping()
    this.timer = window.setInterval(() => this.ping(), this.intervalValue)

    this.onVisibility = () => {
      if (document.visibilityState === 'visible') this.ping()
    }
    document.addEventListener('visibilitychange', this.onVisibility)
  }

  disconnect () {
    if (this.timer) window.clearInterval(this.timer)
    document.removeEventListener('visibilitychange', this.onVisibility)
  }

  isMobile () {
    return window.matchMedia('(max-width: 768px), (pointer: coarse)').matches ||
      /Mobile|Android|iPhone|iPad/i.test(navigator.userAgent || '')
  }

  device () {
    return this.isMobile() ? 'mobile' : 'desktop'
  }

  csrfToken () {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute('content') : ''
  }

  async ping () {
    if (!this.hasUrlValue) return

    // No GPS here - permission only when the user taps share/pin. Server uses IP city.
    const body = {
      path: window.location.pathname + window.location.search,
      device: this.device()
    }

    try {
      await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': this.csrfToken()
        },
        credentials: 'same-origin',
        body: JSON.stringify(body),
        keepalive: true
      })
    } catch (_e) {
      // Ignore network blips - next interval retries.
    }
  }
}
